import React from 'react';
import { openExternalUrl, urlToWeb } from '../utils/external';
import { canShowPurchaseCta, LOCKED_NEUTRAL_TEXT } from '../utils/storeCompliance';

/**
 * LockedNotice — fonctionnalité non incluse dans la formule en cours.
 *
 * ⚠️ CONFORMITÉ APP STORE (règle 3.1.3(f)) — voir utils/storeCompliance.js.
 * Sur iOS, ce composant n'affiche NI bouton, NI lien, NI nom de formule à
 * acheter : un renvoi vers /abonnement est un « call to action for purchase
 * outside of the app », donc un motif de rejet. On se contente de constater
 * que la fonctionnalité n'est pas incluse.
 *
 * Sur le web, le CTA reste en place : c'est le moteur de conversion.
 */
export default function LockedNotice({
  emoji = '🔒',
  title = 'Fonctionnalité non incluse',
  text,
  webText,
  ctaLabel = 'Voir les formules',
}) {
  const withCta = canShowPurchaseCta();
  // Sur natif, on ignore volontairement `webText` : il peut nommer une formule
  // payante, ce que la règle interdit d'utiliser comme incitation.
  const body = withCta ? (webText || text || LOCKED_NEUTRAL_TEXT) : LOCKED_NEUTRAL_TEXT;

  return (
    <div style={styles.wrap}>
      <div style={styles.emoji} aria-hidden>{emoji}</div>
      <div style={styles.title}>{title}</div>
      <p style={styles.text}>{body}</p>
      {withCta && (
        <button
          type="button"
          style={styles.cta}
          onClick={() => openExternalUrl(urlToWeb('/abonnement'))}
        >
          {ctaLabel}
        </button>
      )}
    </div>
  );
}

const styles = {
  wrap: {
    textAlign: 'center',
    padding: '28px 22px',
    background: '#FFFFFF',
    borderRadius: 16,
    border: '1px solid rgba(0,0,0,0.06)',
  },
  emoji: { fontSize: 34, lineHeight: 1, marginBottom: 10 },
  title: { fontSize: 16, fontWeight: 800, color: '#1A1A1A', marginBottom: 6 },
  text: { margin: '0 0 18px', fontSize: 13.5, lineHeight: 1.55, color: '#6B6B6B' },
  cta: {
    background: '#E8502A', color: '#FFFFFF', border: 'none', borderRadius: 999,
    padding: '11px 22px', fontSize: 14.5, fontWeight: 700,
    fontFamily: 'inherit', cursor: 'pointer',
  },
};
